import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// 🔐 API KEY interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const apiKey = import.meta.env.VITE_X_API_KEY;

    if (apiKey) {
      config.headers["X-API-KEY"] = apiKey;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
